import 'angular:locale/data:sr';
import 'angular:locale/data:en';
import 'angular:locale/data:en-x-source';
import 'zone.js';
import './projects/mca-app/src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
